/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Career_1Inputs */

const en_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lead instructor, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const es_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructor principal, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const de_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leitender Ausbilder, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const zh_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`西得梅因 Willow Creek 高尔夫球场首席教练（1980-1984 年）`)
};

const ar_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدرب رئيسي، Willow Creek Golf Course، West Des Moines (1980-1984)`)
};

const fr_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructeur principal, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const vi_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huấn luyện viên chính, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const sw_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mkufunzi mkuu, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const th_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้สอนหลัก สนามกอล์ฟวิลโลว์ครีก เวสต์ดิมอยน์ (1980-1984)`)
};

const bs_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glavni instruktor, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const ja_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リードインストラクター、ウィロークリーク・ゴルフコース、ウェスト・デモイン（1980–1984年）`)
};

const ko_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수석 강사, 윌로우 크릭 골프 코스, 웨스트 Des Moines (1980-1984)`)
};

const pt_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrutor principal, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const it_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istruttore principale, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const sv_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huvudinstruktör, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const nl_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoofdinstructeur, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const da_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ledende instruktør, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const nb_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ledende instruktør, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const fi_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Johtava ohjaaja, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const pl_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruktor wiodący, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const ru_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Главный инструктор, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const tr_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baş eğitmen, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const hi_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुख्य प्रशिक्षक, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const id_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruktur utama, Willow Creek Golf Course, Des Moines Barat (1980-1984)`)
};

const ms_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jurulatih utama, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const cs_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hlavní instruktor, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const el_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επικεφαλής εκπαιδευτής, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const he_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מדריך ראשי, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const af_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoofinstrukteur, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

const hu_about_content_career_1 = /** @type {(inputs: About_Content_Career_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vezető oktató, Willow Creek Golf Course, West Des Moines (1980-1984)`)
};

/**
* | output |
* | --- |
* | "Lead instructor, Willow Creek Golf Course, West Des Moines (1980-1984)" |
*
* @param {About_Content_Career_1Inputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_career_1 = /** @type {((inputs?: About_Content_Career_1Inputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Career_1Inputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_career_1(inputs)
	if (locale === "de") return de_about_content_career_1(inputs)
	if (locale === "zh") return zh_about_content_career_1(inputs)
	if (locale === "ar") return ar_about_content_career_1(inputs)
	if (locale === "fr") return fr_about_content_career_1(inputs)
	if (locale === "vi") return vi_about_content_career_1(inputs)
	if (locale === "sw") return sw_about_content_career_1(inputs)
	if (locale === "th") return th_about_content_career_1(inputs)
	if (locale === "bs") return bs_about_content_career_1(inputs)
	if (locale === "ja") return ja_about_content_career_1(inputs)
	if (locale === "ko") return ko_about_content_career_1(inputs)
	if (locale === "pt") return pt_about_content_career_1(inputs)
	if (locale === "it") return it_about_content_career_1(inputs)
	if (locale === "sv") return sv_about_content_career_1(inputs)
	if (locale === "nl") return nl_about_content_career_1(inputs)
	if (locale === "da") return da_about_content_career_1(inputs)
	if (locale === "nb") return nb_about_content_career_1(inputs)
	if (locale === "fi") return fi_about_content_career_1(inputs)
	if (locale === "pl") return pl_about_content_career_1(inputs)
	if (locale === "ru") return ru_about_content_career_1(inputs)
	if (locale === "tr") return tr_about_content_career_1(inputs)
	if (locale === "hi") return hi_about_content_career_1(inputs)
	if (locale === "id") return id_about_content_career_1(inputs)
	if (locale === "ms") return ms_about_content_career_1(inputs)
	if (locale === "cs") return cs_about_content_career_1(inputs)
	if (locale === "el") return el_about_content_career_1(inputs)
	if (locale === "he") return he_about_content_career_1(inputs)
	if (locale === "af") return af_about_content_career_1(inputs)
	if (locale === "hu") return hu_about_content_career_1(inputs)
	return en_about_content_career_1(inputs)
});